module.exports = __webpack_public_path__ + "static/leftHome@2x-b45180cfb6336985e1c779d41eac3b4a.png";